import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import { Button } from '@unite-us/ui';
import { first, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Form } from 'react-final-form';
import { trackEvent } from '../../../config/api';
import callOrLog from '../../../constants/callOrLog';
import { FACESHEET } from '../../../constants/eventConstants';
import { dateToEpoch } from '../../utils/epoch';
import { useCreateInsurance } from '../hooks/useCreateInsurance';
import { useUpdateInsurance } from '../hooks/useUpdateInsurance';
import { PaymentsInsuranceFields } from './PaymentsInsuranceFields';
export var PaymentsInsuranceForm = function PaymentsInsuranceForm(_ref) {
  var _insurance$plan;
  var closeModal = _ref.closeModal,
    contactId = _ref.contactId,
    isEditing = _ref.isEditing,
    insurance = _ref.insurance;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    formErrors = _useState2[0],
    setFormErrors = _useState2[1];
  var updateInsurance = useUpdateInsurance();
  var createInsurance = useCreateInsurance(contactId);
  var initialValues = {
    plan_type: (_insurance$plan = insurance.plan) === null || _insurance$plan === void 0 ? void 0 : _insurance$plan.plan_type,
    plan_id: insurance.plan.id,
    external_member_id: insurance.external_member_id,
    external_group_id: insurance.external_group_id,
    enrolled_at_converted: !insurance.enrolled_at ? null : dateToEpoch(insurance.enrolled_at),
    expired_at_converted: !insurance.expired_at ? null : dateToEpoch(insurance.expired_at)
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, form) {
      var insuranceData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            insuranceData = {
              plan: values.plan_id,
              external_member_id: values.external_member_id,
              external_group_id: values.external_group_id,
              enrolled_at: values.enrolled_at_converted ? new Date(values.enrolled_at_converted * 1000).toISOString() : null,
              expired_at: values.expired_at_converted ? new Date(values.expired_at_converted * 1000).toISOString() : null
            };
            if (!isEditing) {
              _context.next = 6;
              break;
            }
            _context.next = 4;
            return updateInsurance(insurance.id, insuranceData);
          case 4:
            _context.next = 9;
            break;
          case 6:
            _context.next = 8;
            return createInsurance(insuranceData);
          case 8:
            form.restart();
          case 9:
            callOrLog(function () {
              return trackEvent(FACESHEET.insuranceChanged);
            });
            closeModal();
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onCancel = function onCancel(form) {
    closeModal();
    form.restart();
  };
  var handleFormErrorAccessibility = function handleFormErrorAccessibility() {
    if (!isEmpty(formErrors)) {
      setTimeout(function () {
        var focusableErrInput, focusableErrSelectField;
        var err = first(document.getElementsByClassName('ui-form-field--has-error'));
        if (err) {
          focusableErrInput = first(err === null || err === void 0 ? void 0 : err.getElementsByTagName('input'));
          focusableErrSelectField = first(err === null || err === void 0 ? void 0 : err.getElementsByClassName('choices'));
        }
        if (focusableErrInput && focusableErrSelectField === undefined) {
          var _focusableErrInput;
          focusableErrInput.ariaLabel = formErrors;
          (_focusableErrInput = focusableErrInput) === null || _focusableErrInput === void 0 || _focusableErrInput.focus();
        } else if (focusableErrSelectField) {
          var _focusableErrSelectFi;
          focusableErrSelectField.ariaLabel = formErrors;
          (_focusableErrSelectFi = focusableErrSelectField) === null || _focusableErrSelectFi === void 0 || _focusableErrSelectFi.focus();
        }
        setFormErrors({});
      }, 300);
    } else if (first(document.getElementsByClassName('ui-form-field--has-error'))) {
      var editInsuranceModal = document.getElementById('edit-insurance-modal');
      var errInModal = first(editInsuranceModal === null || editInsuranceModal === void 0 ? void 0 : editInsuranceModal.getElementsByClassName('ui-form-field--has-error'));
      var focusableErrInput = first(errInModal === null || errInModal === void 0 ? void 0 : errInModal.getElementsByTagName('input'));
      var focusableErrSelectField = first(errInModal === null || errInModal === void 0 ? void 0 : errInModal.getElementsByClassName('choices'));
      if (focusableErrInput && focusableErrSelectField === undefined) {
        focusableErrInput === null || focusableErrInput === void 0 || focusableErrInput.focus();
      } else {
        focusableErrSelectField === null || focusableErrSelectField === void 0 || focusableErrSelectField.focus();
      }
    }
  };
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    initialValues: initialValues,
    render: function render(_ref3) {
      var handleSubmit = _ref3.handleSubmit,
        submitting = _ref3.submitting,
        pristine = _ref3.pristine,
        values = _valuesInstanceProperty(_ref3),
        form = _ref3.form;
      return /*#__PURE__*/React.createElement("form", {
        className: "content-with-actions",
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement(PaymentsInsuranceFields, {
        contactId: contactId,
        values: values,
        form: form,
        isEditing: isEditing,
        setFormErrors: setFormErrors
      })), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-insurance-cancel-btn-".concat(insurance.id),
        onClick: function onClick() {
          return onCancel(form);
        },
        disabled: submitting,
        label: "Cancel"
      })), /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-insurance-save-btn-".concat(insurance.id),
        disabled: submitting || pristine,
        label: "Save",
        primary: true,
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                handleFormErrorAccessibility();
                _context2.next = 3;
                return handleSubmit();
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))
      }))));
    }
  });
};
PaymentsInsuranceForm.propTypes = {
  closeModal: PropTypes.func,
  contactId: PropTypes.string.isRequired,
  isEditing: PropTypes.bool,
  insurance: PropTypes.object
};
PaymentsInsuranceForm.defaultProps = {
  closeModal: function closeModal() {},
  isEditing: false,
  insurance: {
    id: null,
    external_member_id: null,
    group_id: null,
    enrolled_at: null,
    expired_at: null,
    plan: {
      id: null,
      plan_type: null
    }
  }
};
//# sourceMappingURL=PaymentsInsuranceForm.js.map